/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-23.
 */
import React, { Component } from 'react';
import { TextField } from 'material-ui';
import { v1 } from 'node-uuid';
import { buildErrorsState, validateField, errorsEmpty } from '../../validations';

const errorsProps = {
    tarifaError: []
};

const rules = {
    tarifaError: [
      { key: 'required', errorText: 'Campo requerido' }
    ]
};

class HonorariosTypeFLAT extends Component {

    constructor() {
        super();
        this.id = v1();
        this.state = {
            tarifa: '',
            errors: {...errorsProps}
        };
    }

    updateHonorarios( value, path2) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path2, value)
        );
        this.setState({ errors });
    }

    render() {
        const { porcentaje, caja, contenedor, errors} = this.state;
        const { notify, searchText= {tarifa:''}} = this.props;

        return (
            <div id={this.id}>
                <div className="col-xs-12">
                    <div className="col-md-12 no-paddings">
                        <div className="col-md-5 pl0">
                            <TextField
                                id={`${this.id}_tarifa`}
                                fullWidth
                                type="number"
                                value={searchText.tarifa}
                                errorText={errors.tarifaError.join(' | ')}
                                onChange={(event, value) => {
                                    this.setState({ tarifa: value });
                                    this.updateHonorarios( value, 'tarifaError')
                                    notify({ tarifa: value});
                                }}
                            />
                        </div>
                        <p style={{marginTop:'8%'}}>Tarifa FLAT</p>
                    </div>
                </div>

            </div>
        );
    }
}

export default HonorariosTypeFLAT;



// WEBPACK FOOTER //
// ./forms/customTabulador/honorariosTypeFLAT.js